/**
 * Stable CSS class names for E2E — MP payment on delivery commission.
 */
export const MPODC = {
    page: 'mp-payment-on-delivery-commission-page',
    shellPaper: 'mp-payment-on-delivery-commission-page__shell',
    loadingSection: 'mp-payment-on-delivery-commission-page__loading-section',
    breadcrumbSection: 'mp-payment-on-delivery-commission-page__breadcrumb-section',
    tabsWrap: 'mp-payment-on-delivery-commission-page__tabs-wrap',
    tabsRoot: 'mp-payment-on-delivery-commission-page__tabs',
    tabList: 'mp-payment-on-delivery-commission-page-input--tab-list',
    tabBulkUpload: 'mp-payment-on-delivery-commission-page-input--tab-bulk-upload',
    tabPanelList: 'mp-payment-on-delivery-commission-page__tab-panel-list',
    tabPanelBulkUpload: 'mp-payment-on-delivery-commission-page__tab-panel-bulk-upload',

    listTabRoot: 'mp-payment-on-delivery-commission-list-tab',

    companyFilterOuter: 'mp-payment-on-delivery-commission-company-filter',
    companyFilterPaper: 'mp-payment-on-delivery-commission-company-filter__paper',
    companyFilterCompanyField: 'mp-payment-on-delivery-commission-company-filter__company-field',
    inputSelectCompanyFilter: 'mp-payment-on-delivery-commission-company-filter-input--select-company',
    inputButtonCompanyFilter: 'mp-payment-on-delivery-commission-company-filter-input--button-filter',

    commissionListRoot: 'mp-payment-on-delivery-commission-commission-list',
    commissionListToolbarBack: 'mp-payment-on-delivery-commission-commission-list__toolbar-back',
    inputButtonCommissionListBack: 'mp-payment-on-delivery-commission-commission-list-input--button-back',
    commissionListToolbarActions: 'mp-payment-on-delivery-commission-commission-list__toolbar-actions',
    inputButtonCommissionListAdd: 'mp-payment-on-delivery-commission-commission-list-input--button-add',
    inputButtonCommissionListExport: 'mp-payment-on-delivery-commission-commission-list-input--button-export-excel',
    commissionListGridWrap: 'mp-payment-on-delivery-commission-commission-list__grid-wrap',
    datagridActionsCell: 'mp-payment-on-delivery-commission-datagrid-actions-cell',
    inputButtonRowEdit: 'mp-payment-on-delivery-commission-datagrid-input--button-row-edit',
    inputButtonRowDelete: 'mp-payment-on-delivery-commission-datagrid-input--button-row-delete',

    codDrawerBody: 'mp-payment-on-delivery-commission-drawer',
    codDrawerFields: 'mp-payment-on-delivery-commission-drawer__fields',
    codDrawerFieldCompany: 'mp-payment-on-delivery-commission-drawer__field-company',
    inputSelectDrawerCompany: 'mp-payment-on-delivery-commission-drawer-input--select-company',
    inputTextDrawerMinPrice: 'mp-payment-on-delivery-commission-drawer-input--text-min-price',
    inputTextDrawerMaxPrice: 'mp-payment-on-delivery-commission-drawer-input--text-max-price',
    inputTextDrawerCommission: 'mp-payment-on-delivery-commission-drawer-input--text-commission',
    codDrawerDateSection: 'mp-payment-on-delivery-commission-drawer__date-section',
    codDrawerDateRangeWrap: 'mp-payment-on-delivery-commission-drawer__date-range-wrap',
    codDrawerActionsRow: 'mp-payment-on-delivery-commission-drawer__actions-row',
    inputButtonDrawerClear: 'mp-payment-on-delivery-commission-drawer-input--button-clear',
    inputButtonDrawerSave: 'mp-payment-on-delivery-commission-drawer-input--button-save',

    bulkTabRoot: 'mp-payment-on-delivery-commission-bulk-tab',
    bulkTabTitle: 'mp-payment-on-delivery-commission-bulk-tab__title',
    bulkTabSubtitle: 'mp-payment-on-delivery-commission-bulk-tab__subtitle',
    bulkTabCompanyField: 'mp-payment-on-delivery-commission-bulk-tab__company-field',
    inputSelectBulkTabCompany: 'mp-payment-on-delivery-commission-bulk-tab-input--select-company',
    bulkTabRulesPaper: 'mp-payment-on-delivery-commission-bulk-tab__rules-paper',
    bulkTabUploadWrap: 'mp-payment-on-delivery-commission-bulk-tab__upload-wrap',
    bulkTabStatusRow: 'mp-payment-on-delivery-commission-bulk-tab__status-row',
    bulkTabFailedSection: 'mp-payment-on-delivery-commission-bulk-tab__failed-section',
    bulkTabFailedTitle: 'mp-payment-on-delivery-commission-bulk-tab__failed-title',
    bulkTabFailedGridWrap: 'mp-payment-on-delivery-commission-bulk-tab__failed-grid-wrap',
} as const;

export const mpodcCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
